// extracted by mini-css-extract-plugin
export default {"layoutSidebar":"Sidebar_layoutSidebar__1ny8N","layoutSidebar--closed":"Sidebar_layoutSidebar--closed__geOS+","layoutSidebar--collapsed":"Sidebar_layoutSidebar--collapsed__Iwl91"};